import { render, staticRenderFns } from "./blog-detail.vue?vue&type=template&id=40c3392f&"
import script from "./blog-detail.vue?vue&type=script&lang=js&"
export * from "./blog-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports